<template>
  <div class="spliter">
    <div class="spliter-con">
      <multipane
        class="custom-resizer"
        layout="vertical"
      >
        <role-tree ref="box1" @selectedRole="selectedRole" />
        <multipane-resizer />
        <role-user-list ref="box2" 
          @selectedRoleUser="selectedRoleUser"
          @searchFilter="searchRoleUserList"
        />
      </multipane>
    </div>
    <div class="dialog-footer align-r">
      <el-button type="primary" @click="selectRole" v-if="!isRequiredUser">{{ $t("messages.btnRoleUser") }}</el-button>
      <el-button type="primary" @click="selectRoleUser">{{ $t("messages.btnSelectUser") }}</el-button>
      <el-button type="info" @click="closeRoleUserModal">{{ $t("messages.btnCancel") }}</el-button>
    </div>
  </div>
</template>

<script>
import commonMixin from "@/mixins/commonMixin";
import { Multipane, MultipaneResizer } from "vue-multipane";
import RoleTree from '@/components/systemMgComponents/RoleTree.vue';
import RoleUserList from '@/components/systemMgComponents/RoleUserList.vue';

export default {
  mixins: [commonMixin],
  components: {
    Multipane,
    MultipaneResizer,
    RoleTree,
    RoleUserList,
  },
  props: {
    isRequiredUser: {
      value: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedRoleInfo : {},
      selectedRoleUserInfo : {},
    }
  },
  methods: {
    selectedRole(role) {
      this.selectedRoleInfo = role;
      this.$EventBus.$emit("selectedRole", this.selectedRoleInfo);
    },
    selectedRoleUser(roleUser) {
      this.selectedRoleUserInfo = roleUser;
    },
    searchRoleUserList(searchFilterData) {
      const roleId = this.selectedRoleInfo.roleId;
      if (!roleId) {
        alert('선택 된 권한 정보가 없습니다.');
        return;
      }
      this.getRoleUserList(roleId, searchFilterData);
    },
    resetData() {
      this.roleUserList = [];
      this.selectedRoleInfo = {};
      this.selectedRoleUserInfo = {};
    },
    closeRoleUserModal() {
      this.$emit("closeRoleUserModal");

      this.resetData();
    },
    selectRole() {
      if (Object.keys(this.selectedRoleInfo).length <= 0) {
        alert('선택 된 권한 정보가 없습니다.');
        return;
      } 
      
      if (confirm("권한명 [" + this.selectedRoleInfo.roleNm + "] 을 선택 하시겠습니까?")) {
        this.$emit("selectedRoleUserInfo", this.selectedRoleInfo, {});
        this.resetData();
      }
    },
    selectRoleUser() {
      if (Object.keys(this.selectedRoleUserInfo).length <= 0) {
        alert('선택 된 사용자 정보가 없습니다.');
        return;
      } 

      if (confirm("권한명 [" + this.selectedRoleInfo.roleNm + "] 사용자명 [" + this.selectedRoleUserInfo.userNm + "] 을 선택 하시겠습니까?")) {
        this.$emit("selectedRoleUserInfo", this.selectedRoleInfo, this.selectedRoleUserInfo);     
        this.resetData();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.select-popup {
  height:300px;
}
.align-button-input {
  display:flex;
  justify-content: center;
  padding-bottom: 20px;
}
</style>